.animate-like {
  --duration: '';

  @apply transition repeat-1 fill-mode-both;
  transition-duration: var(--duration);
  animation-name: animation-like;
  animation-duration: calc(var(--duration) * 2);
}

.animate-unlike {
  @apply transition;
  transition-duration: var(--duration);
  animation-name: animation-unlike;
  animation-duration: calc(var(--duration) * 2);
}

@keyframes animation-like {
  50% {
    transform: scale(1.2);
  }
}

@keyframes animation-unlike {
  50% {
    transform: scale(0.8);
  }
}
